import React from 'react';
import styled from 'styled-components';
import { RefundSectionProps } from '../RefundGuidePage/RefundSection';
import CheckboxIcon from './CheckboxIcon';

const s = {
  Container: styled.label<{ checked: boolean }>`
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
    outline: none;
    width: 167px;
    height: 170px;
    border: 1px solid ${(props) => (props.checked ? '#000000' : '#D9D9D9')};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px;
    &:hover,
    &:focus {
      border-color: black;
    }
  `,
  HiddenCheckbox: styled.input`
    position: absolute;
    visibility: hidden;
    cursor: pointer;
    height: 0;
    width: 0;
  `,
  CheckboxIcon: styled(CheckboxIcon)`
    position: absolute;
    top: 8px;
    left: 8px;
  `,
  Title: styled.p``,
};

export type ServiceCardProps = {
  selected: boolean;
  onSelection: (selected: boolean) => void;
  data: RefundSectionProps;
};

const ServiceCard = ({ selected, onSelection, data: { title } }: ServiceCardProps) => (
  <s.Container htmlFor={title} tabIndex={0} checked={selected}>
    <s.HiddenCheckbox
      type="checkbox"
      id={title}
      value={title}
      checked={selected}
      onChange={() => onSelection(!selected)}
      tabIndex={-1}
    />
    <s.CheckboxIcon checked={selected} />
    <s.Title>{title}</s.Title>
  </s.Container>
);

export default ServiceCard;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/RefundSelectionPage/ServiceCard.tsx